const defaultParamsByType: Record<string, any> = {
  azurerm_purview_account: {
    name: "purview-governance",
    resource_group_name: "",
    location: "West Europe",
    identity_type: "SystemAssigned",
    public_network_enabled: false,
    purviewMode: "deploy",
  },
  data_factories: {
    adfName: "",
    identity: "SystemAssigned",
    location: "West Europe",
  },
  sql_database: {
    model: "vCore",
    tier: "GeneralPurpose",
    capacity: 2,
    size: "5GB",
    family: "Gen5",
    sqlName: "my-sqldb",
    adminUser: "sqladmin",
    adminPassword: "StrongPassword123!",
    region: "West Europe",
    backupRetention: 7,
  },
  storage_accounts: {
    name: "mystorage",
    sku: "Standard_LRS",
    location: "West Europe",
    kind: "StorageV2",
    isHnsEnabled: false,
    accessTier: "Hot",
  },
  virtual_machine: {
    name: "",
    location: "West Europe",
    size: "Standard_DS1_v2",
    osType: "Linux",
    adminUsername: "",
    adminPassword: "",
    networkInterfaceId: "",
  },
  // Terraform Azure Resources
  azurerm_resource_group: {
    name: "rg-default",
    location: "westeurope",
    tags: {},
  },
  azurerm_virtual_network: {
    name: "vnet-default",
    resource_group_name: "",
    location: "westeurope",
    address_space: ["10.0.0.0/16"],
    tags: {},
  },
  azurerm_subnet: {
    name: "subnet-default",
    resource_group_name: "",
    virtual_network_name: "",
    address_prefixes: ["10.0.1.0/24"],
  },
  azurerm_network_interface: {
    name: "nic-default",
    location: "westeurope",
    resource_group_name: "",
    subnet_id: "",
    private_ip_address_allocation: "Dynamic",
    network_security_group_id: "",
  },
  azurerm_virtual_machine: {
    name: "vm-default",
    location: "westeurope",
    resource_group_name: "",
    network_interface_ids: [],
    vm_size: "Standard_DS1_v2",
    delete_os_disk_on_termination: true,
    delete_data_disks_on_termination: true,
    storage_image_reference: {
      publisher: "Canonical",
      offer: "UbuntuServer",
      sku: "18.04-LTS",
      version: "latest",
    },
    storage_os_disk: {
      name: "osdisk",
      caching: "ReadWrite",
      create_option: "FromImage",
      managed_disk_type: "Standard_LRS",
    },
    os_profile: {
      computer_name: "hostname",
      admin_username: "azureuser",
      admin_password: "Password1234!",
    },
    os_profile_linux_config: {
      disable_password_authentication: false,
    },
  },
  azurerm_linux_virtual_machine: {
    name: "vm-linux-default",
    location: "westeurope",
    resource_group_name: "",
    network_interface_ids: [],
    size: "Standard_DS1_v2",
    admin_username: "azureuser",
    admin_password: "Password1234!",
    disable_password_authentication: false,
    os_disk: {
      caching: "ReadWrite",
      storage_account_type: "Standard_LRS",
    },
    source_image_reference: {
      publisher: "Canonical",
      offer: "UbuntuServer",
      sku: "18.04-LTS",
      version: "latest",
    },
  },
  azurerm_windows_virtual_machine: {
    name: "vm-windows-default",
    location: "westeurope",
    resource_group_name: "",
    network_interface_ids: [],
    size: "Standard_DS1_v2",
    admin_username: "azureuser",
    admin_password: "Password1234!",
    os_disk: {
      caching: "ReadWrite",
      storage_account_type: "Standard_LRS",
    },
    source_image_reference: {
      publisher: "MicrosoftWindowsServer",
      offer: "WindowsServer",
      sku: "2019-Datacenter",
      version: "latest",
    },
  },
  azurerm_network_security_group: {
    name: "nsg-default",
    location: "westeurope",
    resource_group_name: "",
    security_rule: [],
  },
  virtual_networks: {
    name: "",
    addressSpace: "10.0.0.0/16",
    location: "West Europe",
  },
  network_interfaces: {
    name: "",
    subnetId: "",
    privateIPAllocationMethod: "Dynamic",
  },
  network_security_groups: {
    name: "",
    location: "West Europe",
    securityRules: [],
  },
  load_balancers: {
    name: "",
    sku: "Standard",
    location: "West Europe",
  },
  application_gateways: {
    name: "",
    location: "West Europe",
    tier: "Standard_v2",
    capacity: 2,
  },
  key_vaults: {
    name: "",
    location: "West Europe",
    tenantId: "",
    skuName: "standard",
  },
  app_services: {
    name: "",
    location: "West Europe",
    appServicePlanId: "",
    runtimeStack: "NODE|14-lts",
  },
  api_managements: {
    name: "",
    location: "West Europe",
    publisherEmail: "",
    publisherName: "",
    sku: "Developer",
  },
  kubernetes_services: {
    name: "",
    location: "West Europe",
    dnsPrefix: "",
    agentCount: 3,
    agentVMSize: "Standard_DS2_v2",
  },
  container_registries: {
    name: "",
    location: "West Europe",
    sku: "Basic",
    adminEnabled: true,
  },
  cosmos_dbs: {
    name: "",
    location: "West Europe",
    kind: "MongoDB",
    consistencyPolicy: "Session",
  },
  redis_caches: {
    name: "",
    location: "West Europe",
    capacity: 1,
    family: "C",
    sku: "Basic",
  },
  function_apps: {
    name: "",
    location: "West Europe",
    storageAccountName: "",
    appServicePlanId: "",
    runtimeStack: "dotnet",
  },
  logic_apps: {
    name: "",
    location: "West Europe",
    definition: {},
  },
  event_hubs: {
    name: "",
    namespaceName: "",
    location: "West Europe",
    partitionCount: 2,
    messageRetentionInDays: 7,
  },
  service_buses: {
    name: "",
    namespaceName: "",
    location: "West Europe",
    sku: "Standard",
  },

  // ============================================
  // AWS Resources
  // ============================================
  aws_vpc: {
    cidr_block: "10.0.0.0/16",
    enable_dns_hostnames: true,
    enable_dns_support: true,
    tags: {},
  },
  aws_subnet: {
    vpc_id: "",
    cidr_block: "10.0.1.0/24",
    availability_zone: "",
    map_public_ip_on_launch: false,
    tags: {},
  },
  aws_instance: {
    ami: "ami-0c55b159cbfafe1f0", // Amazon Linux 2
    instance_type: "t3.micro",
    subnet_id: "",
    vpc_security_group_ids: [],
    key_name: "",
    associate_public_ip_address: false,
    tags: {},
  },
  aws_security_group: {
    name: "sg-default",
    description: "Security group",
    vpc_id: "",
    ingress: [],
    egress: [],
    tags: {},
  },
  aws_db_subnet_group: {
    name: "db-subnet-group",
    description: "Database subnet group",
    subnet_ids: [],
    tags: {},
  },
  aws_db_instance: {
    identifier: "db-default",
    engine: "mysql",
    engine_version: "8.0",
    instance_class: "db.t3.micro",
    allocated_storage: 20,
    storage_type: "gp2",
    db_name: "mydb",
    username: "admin",
    password: "Password123!",
    vpc_security_group_ids: [],
    db_subnet_group_name: "",
    skip_final_snapshot: true,
    tags: {},
  },
  aws_s3_bucket: {
    bucket: "my-bucket",
    acl: "private",
    versioning_enabled: false,
    tags: {},
  },
  aws_lambda_function: {
    function_name: "lambda-default",
    runtime: "nodejs18.x",
    handler: "index.handler",
    role: "",
    filename: "lambda.zip",
    source_code_hash: "",
    timeout: 30,
    memory_size: 128,
    environment: {
      variables: {},
    },
    vpc_config: {
      subnet_ids: [],
      security_group_ids: [],
    },
    tags: {},
  },

  // ─── Microsoft Fabric ─────────────────────────────────────────────
  fabric_capacity: {
    display_name: "",
    name: "fc-default",
    sku: "F8",
    location: "West Europe",
    adminMembers: [],
  },
  fabric_workspace: {
    display_name: "",
    name: "ws-default",
    capacityId: "",
    description: "",
    identity: "None",
    roleAssignments: [],
  },
  fabric_deployment_pipeline: {
    name: "dp-default",
    description: "",
    stages: 3,
  },
  fabric_lakehouse: {
    display_name: "",
    name: "lh-default",
    workspaceId: "",
    enableSchemas: true,
  },
  fabric_warehouse: {
    display_name: "",
    name: "wh-default",
    workspaceId: "",
  },
  fabric_pipeline: {
    display_name: "",
    name: "pipeline-default",
    workspaceId: "",
    description: "",
  },
  fabric_notebook: {
    display_name: "",
    name: "nb-default",
    workspaceId: "",
    language: "SparkR",
  },
  fabric_semantic_model: {
    display_name: "",
    name: "sm-default",
    workspaceId: "",
    defaultMode: "Import",
  },
  fabric_ml_model: {
    display_name: "",
    name: "ml-default",
    workspaceId: "",
  },
  fabric_sql_database: {
    display_name: "",
    name: "sqldb-default",
    workspaceId: "",
    collation: "Latin1_General_100_BIN2_UTF8",
  },
  fabric_onelake: {
    display_name: "",
    name: "onelake-default",
    workspaceId: "",
  },
  fabric_dataflow: {
    display_name: "",
    name: "df-default",
    workspaceId: "",
    description: "",
  },
  fabric_report: {
    display_name: "",
    name: "report-default",
    workspaceId: "",
    description: "",
  },
  fabric_data_agent: {
    display_name: "",
    name: "agent-default",
    workspaceId: "",
    description: "",
  },
  fabric_eventstream: {
    display_name: "",
    name: "es-default",
    workspaceId: "",
    description: "",
  },
  fabric_eventhouse: {
    display_name: "",
    name: "eh-default",
    workspaceId: "",
    description: "",
  },
  fabric_kql_database: {
    display_name: "",
    name: "kql-default",
    workspaceId: "",
    eventhouseId: "",
  },

  fabric_domain: {
    name: "domain-default",
    description: "",
    parentDomainId: "",
    contributorsScope: "SpecificUsersAndGroups",
  },

  // ─── Databricks ───────────────────────────────────────────────────
  databricks_workspace: {
    name: "dbw-default",
    location: "West Europe",
    sku: "premium",
    managedResourceGroupName: "rg-dbw-managed",
  },
  databricks_unity_catalog: {
    name: "uc-default",
    metastoreId: "",
    storageRoot: "",
  },
  databricks_cluster: {
    name: "cluster-default",
    sparkVersion: "13.3.x-scala2.12",
    nodeTypeId: "Standard_DS3_v2",
    numWorkers: 2,
    autoterminationMinutes: 30,
  },
  databricks_sql_warehouse: {
    name: "sql-wh-default",
    clusterSize: "Small",
    maxNumClusters: 1,
    autoStopMins: 10,
  },
  databricks_mlflow: {
    name: "mlflow-default",
    artifactLocation: "dbfs:/mlflow",
  },
};

export default defaultParamsByType;
